import "./styles/app.css"
import { createInitialState } from "./app/state/AppState"
import { StateStore } from "./app/state/StateStore"
import { RenderEngine } from "./render/RenderEngine"
import { ApiClient } from "./app/api/ApiClient"

import { AuthManager, AuthState } from "./app/auth/AuthManager"

import { NoticeScreen } from "./render/screens/NoticeScreen"
import type { Screen } from "./app/api/ApiClient"

const root = document.getElementById("app")
if (!root) throw new Error("Root element #app not found")

const BASE_URL = "https://fr.bezbolu.pro"

import { loadState } from "./app/state/persistence"

const persisted = loadState()
console.log("LOAD", persisted)

const initialState = createInitialState()

if (persisted) {

  // 👉 восстанавливаем только если это тот же крок
  if (persisted.currentKrokId) {
    initialState.currentKrokId = persisted.currentKrokId
    initialState.gaps = persisted.gaps || {}
    initialState.revealed = persisted.revealed || {}
  }

  initialState.scrollY = persisted.scrollY || 0
}

const store = new StateStore(initialState)

// -----------------------------
// читаем /auth?sticker
// -----------------------------




// ==============================
// ROUTE PARSER (NEW)
// ==============================

function getInitialRoute() {

  const params = new URLSearchParams(window.location.search)

 
  // Сохраняем только маркетинговые параметры
  const referral = new URLSearchParams(params)

  referral.delete("auth")
  referral.delete("sticker")

  return {
    isAuth: params.has("auth"),
    sticker: params.get("sticker"),
    referral: referral.toString()
  }
}



const auth = new AuthManager(BASE_URL)
const api = new ApiClient(BASE_URL, auth)
;(window as any).auth = auth


let paymentInProgress = false

    function applyScreen(screen: Screen) {

      const state = store.getState()

      console.log("APPLY SCREEN:", screen.type)

      // =========================
      // OTP
      // =========================

      if (screen.type === "otp") {

        store.replace({
          ...state,

          primaryScreen: {
            type: "otp",
            email: (screen as any).email
          },

          isLoading: false
        })

        return
      }

      // =========================
      // KROK
      // =========================

      if (screen.type === "krok") {

        store.replace({
          ...state,

          currentKrokId: screen.id,
          krok: screen,

          gaps:
            state.currentKrokId === screen.id
              ? state.gaps
              : {},

          revealed:
            state.currentKrokId === screen.id
              ? state.revealed
              : {},

          primaryScreen: { type: "core" },

          isLoading: false
        })

        return
      }

      // =========================
      // NOTICE
      // =========================

      if (screen.type === "notice") {

        store.replace({
          ...state,

          primaryScreen: {
            type: "notice",

            noticeType:
              screen.noticeType === "next"
                ? "next_available"
                : screen.noticeType,

            nextKrokId: screen.nextKrokId ?? null,

            notice: (screen as any).data ?? [],

            continueProducts:
              (screen as any).continueProducts ?? []
          },

          isLoading: false
        })

        return
      }

      // =========================
      // ACCOUNT
      // =========================

      if (screen.type === "account") {

        store.replace({
          ...state,

          primaryScreen: { type: "account" },

          krok: null,
          currentKrokId: null,

          accountData: (screen as any).data ?? null,
          isAccountLoading: false,

          isLoading: false
        })

        return
      }

      // =========================
      // SUBSCRIPTIONS
      // =========================

      if (screen.type === "subscriptions") {

        store.replace({
          ...state,

          primaryScreen: { type: "subscriptions" },

          stickers: screen.available_stickers ?? [],

          currentSticker: screen.current_sticker ?? null,

          productTitle: screen.product_title ?? null,

          isLoading: false
        })

        return
      }

      // =========================
      // confirmChange
      // =========================

      if (screen.type === "confirmChange") {

        store.replace({
          ...state,
          selectedSticker: screen.new_sticker?.id ?? null,
          primaryScreen: {
            type: "confirmChange",
            data: screen
          },

          isLoading: false
        })

        return
      }

      if (screen.type === "otp") {

          store.replace({
            ...state,

            primaryScreen: {
              type: "otp",
              email: (screen as any).email
            },

            isLoading: false
          })

          return
        }


      console.error("UNKNOWN SCREEN", screen)
    }


    function mapApiScreenToApp(screen: Screen): any {

      if (screen.type === "confirmChange") {
        return {
          type: "confirmChange",
          data: screen
        }
      }

      if (screen.type === "subscriptions") {
        return {
          type: "subscriptions"
        }
      }

      if (screen.type === "krok") {
        return {
          type: "core"
        }
      }

      if (screen.type === "notice") {
        return {
          type: "notice",

          noticeType:
            screen.noticeType === "next"
              ? "next_available"
              : screen.noticeType,

          nextKrokId: screen.nextKrokId ?? null,

          notice: (screen as any).data ?? [],

          continueProducts:
            (screen as any).continueProducts ?? []
        }
      }

      if (screen.type === "account") {
        return { type: "account" }
      }

      return { type: "auth" }
    }

  const renderEngine = new RenderEngine(root, store, {
      applyScreen,

      // =========================
      // LOGIN
      // =========================

      onLogin: async (email, password) => {

        // сохраняем состояние до логина
        const stateBeforeLogin = store.getState()
        const sticker = stateBeforeLogin.selectedSticker

        await auth.login(email, password)

       
        // если пользователь пришёл с Landing оплаты
        if (sticker) {

          try {

        const result = await api.subscribe(sticker, "UAH")
        
        // 🔥 1. если backend вернул screen (confirmChange)
        if ((result as any).screen) {
            applyScreen((result as any).screen)
            return
        }

        if ((result as any).redirect_url) {
            window.location.href =
                (result as any).redirect_url
            return
        }

        throw new Error(
            "Unexpected subscribe response"
        )

            return

          } catch (err) {

            console.error("Subscribe error:", err)
            alert("Помилка створення платежу")

            return
          }

        }

        // обычный flow приложения
     
        const res = await api.getEntry()
        applyScreen(res.screen)

      },


onRequestOtp: async (email: string) => {

      

    await auth.requestOtp(
        email,
        store.getState().referral
    )

},

      onConfirmOtp: async (email, otp) => {

        await auth.confirmOtp(email, otp)

        const state = store.getState()

        if (state.selectedSticker) {

          try {

            const result = await api.subscribe(
              state.selectedSticker,
              "UAH"
            )

                    console.log(
              "OTP SUBSCRIBE RESULT",
              JSON.stringify(result, null, 2)
            )    

            if ((result as any).screen) {
              applyScreen((result as any).screen)
              return
            }

            console.log(
            "OTP RESULT BEFORE REDIRECT",
            result
          )

          if ((result as any).redirect_url) {

            window.location.href =
              (result as any).redirect_url

            return
          }

          console.error(
            "Unexpected subscribe result",
            result
          )

          return

          } catch (e) {

console.error("OTP FLOW ERROR", e)

            alert("Помилка створення платежу")
            return
          }
        }

        const res = await api.getEntry()
        applyScreen(res.screen)
      },

      onResendOtp: async (email) => {
        await auth.requestOtp(email)
      },

    // =========================
    // REGISTER
    // =========================

    onRegister: async (email, password) => {
      
      await auth.register(email, password)

      // 👉 сохраняем email для OTP шага
      store.update(prev => ({
        ...prev,
        primaryScreen: {
          type: "otp",
          email
        }
      }))

    },
    
    // =========================
    // SUBSCRIBE
    // =========================

    onSubscribeClick: async (stickerId, currency) => {

      if (paymentInProgress) return
      paymentInProgress = true

      try {

        const result = await api.subscribe(stickerId, currency)

        // 🔥 confirmChange через screen
        if ((result as any).screen) {
          paymentInProgress = false   // ✅ FIX
          applyScreen((result as any).screen)
          return
        }

        // 🔥 redirect flow
        if ((result as any).redirect_url) {
          window.location.href = (result as any).redirect_url
          return // 🔥 НЕ сбрасываем — уходим со страницы
        }

        // 🔥 fallback (если вдруг формат другой)
        if ((result as any).redirect_url) {
            window.location.href =
                (result as any).redirect_url
            return
        }

        throw new Error(
            "Unexpected subscribe response"
        )

      } catch (e) {

        console.error("Subscribe error:", e)

        paymentInProgress = false   // ✅ FIX
        alert("Payment failed")

      }

    },

      // =========================
      // CORE
      // =========================

      onCompleteClick: async () => {

        const state = store.getState()

        if (!state.currentKrokId) return

        const res = await api.complete(state.currentKrokId)

        applyScreen(res.screen)
      },

      
    onContinueClick: async () => {
      const res = await api.getEntry()
      applyScreen(res.screen)
    },
      onPrevClick: async () => {

      const state = store.getState()

      const prevId = state.krok?.prev_krok_id

      if (!prevId) return

      const res = await api.navigate(prevId)
      applyScreen(res.screen)
          },
    onNextClick: async () => {

        const state = store.getState()

        const nextId = state.krok?.next_krok_id

        if (!nextId) return

        const res = await api.navigate(nextId)
        applyScreen(res.screen)
        },

    onEntryClick: async () => {

      const res = await api.entryKrok()
      applyScreen(res.screen)
          },

      onListClick: async () => {

          const state = store.getState()

          // 🔥 сохраняем откуда пришли
          const from = state.primaryScreen

          // показываем экран + loading
          store.update(prev => ({
            ...prev,
            primaryScreen: { type: "list", from },
            isListLoading: true
          }))

          try {

        const res = await api.getCompletedList()

        const screen = res.screen

        store.update(prev => ({
          ...prev,

          // 🔥 ВАЖНО: меняем primaryScreen тоже
          primaryScreen: {
            ...prev.primaryScreen
          },

          completedProducts: [...((screen as any).products ?? [])],
          isListLoading: false
        }))




          } catch (e) {

            store.update(prev => ({
              ...prev,
              isListLoading: false
            }))

            alert("Ошибка загрузки списка")
          }
        },

    
      onBackClick: () => {

        const state = store.getState()

        // =========================²
        // RESOLVE BACK STRATEGY
        // =========================

        const screen = state.primaryScreen as any

        // 1. есть from → нормальный возврат
        if (screen.from) {
          store.update(prev => ({
            ...prev,
            primaryScreen: screen.from
          }))
          return
        }

        // 2. есть krok → можно в core
        if (state.krok && state.currentKrokId) {
          store.update(prev => ({
            ...prev,
            primaryScreen: { type: "core" }
          }))
          return
        }

        // 3. fallback → ЖЁСТКИЙ RELOAD
        console.warn("BACK FALLBACK → RELOAD")

        window.location.reload()

      },

        
      onOpenKrokFromList: async (krokId) => {

        const state = store.getState()

        const res = await api.navigate(krokId)
        applyScreen(res.screen)
              },

      onToggleLesson: (lessonId) => {

        store.update(prev => {

          const isOpen = prev.expandedLessons[lessonId]

          return {
            ...prev,
            expandedLessons: {
              ...prev.expandedLessons,
              [lessonId]: !isOpen
            }
          }
        })
      },
        
      onUserClick: async () => {

        const state = store.getState()

        const from = state.primaryScreen

        store.update(prev => ({
          ...prev,
          primaryScreen: { type: "account", from },
          isAccountLoading: true
        }))

        try {

          const res = await api.getAccount()

          store.update(prev => ({
            ...prev,
            accountData: res,
            isAccountLoading: false
          }))

        } catch {

          store.update(prev => ({
            ...prev,
            isAccountLoading: false
          }))

          alert("Помилка завантаження акаунта")
        }

      },

      onFetchSubscriptions: async (
        productId: string
      ) => {

        return await api.getSubscription(
          productId
        )

      },


            onConfirmChangeClick: async (
        stickerId: string
      ) => {

        try {

          const result =
            await api.confirmChange(
              stickerId
            )

          if ((result as any).screen) {

            applyScreen(
              (result as any).screen
            )

            return
          }

          console.error(
            "confirm-change returned unexpected payload",
            result
          )

        } catch (e) {

          console.error(
            "Confirm change error:",
            e
          )

          alert(
            "Помилка завантаження підтвердження зміни підписки"
          )
        }
      },


      onConfirmSubscriptionChange: async (stickerId: string) => {
        return await api.subscribe(stickerId, "UAH", true)
      },

      onCancelSubscription: async (
        subscriptionId: string
      ) => {

        return await api.cancelSubscription(
          subscriptionId
        )
      },

      onLogout: async () => {

        await auth.logout()

        window.location.reload()

      },

      onOpenRepeatClick: () => {},
    

    onOpenKrokFromRepeat: () => {},
    onReturnToCurrentClick: () => {}

  })

store.subscribe(state => renderEngine.render(state))

renderEngine.render(store.getState())

    ;(async () => {

    try {

      const route = getInitialRoute()
      
      // =========================
      // 🔥 AUTH FLOW (landing → subscribe)
      // =========================

      if (route.isAuth) {

        // если есть sticker → subscribe auth
      if (route.sticker) {

                store.replace({
          ...store.getState(),

          selectedSticker: route.sticker,

          referral:
            route.referral && route.referral.length > 0
              ? route.referral
              : null,

          primaryScreen: {
            type: "subscribeAuth"
          },

          isBooting: false
        })


        // 🔥 очистка URL
        
        window.history.replaceState({}, "", window.location.pathname)

        return
      }

        // обычный auth
      store.replace({
        ...store.getState(),

        referral:
          route.referral && route.referral.length > 0
            ? route.referral
            : null,

        primaryScreen: { type: "auth" },

        isBooting: false
      })

      // 🔥 очистка URL
      window.history.replaceState({}, "", window.location.pathname)

      return
      }

      // =========================
      // 🔥 NORMAL FLOW
      // =========================


        await auth.waitUntilAuthenticated()

        const res = await api.getEntry()
        applyScreen(res.screen)

      } catch {
      store.replace({
        ...store.getState(),
        primaryScreen: { type: "auth" },
        isBooting: false
      })

    }

  })()